import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import FormGroup from '../../../../components/FormGroup';
import Input from '../../../../components/Input';
import MyModal from '../../../../components/Modal';
import onlyNumbers from '../../../../utils/onlyNumbers';

interface ISearchByCodeModal {
  searchByCodeModalShow: boolean;
  setSearchByCodeModalShow: Dispatch<SetStateAction<boolean>>;
  searchByCode: (code: string | number) => Promise<void>;
}

export default function SearchByCodeModal({
  searchByCodeModalShow,
  setSearchByCodeModalShow,
  searchByCode,
}: ISearchByCodeModal) {
  const [consultCode, setConsultCode] = useState<string | number>('');

  function handleCodeChange(event: ChangeEvent<HTMLInputElement>) {
    setConsultCode(onlyNumbers(event.target.value));
  }

  const isValidToSearchByCpf = !!consultCode;

  return (
    <MyModal
      show={searchByCodeModalShow}
      title={'Pesquisar por Código da Consulta'}
      closeButtonLabel="Fechar"
      actionButtonLabel={'Pesquisar'}
      onClose={() => setSearchByCodeModalShow(false)}
      onAction={() => searchByCode(consultCode)}
      isActionButtonDisabled={!isValidToSearchByCpf}
      type="action"
      size='lg'
      modalBody={(
        <FormGroup>
          <label htmlFor="contactName">Digite o Código da Consulta</label>
          <Input
            value={consultCode}
            onChange={handleCodeChange}
            placeholder="000000"
            maxLength={14}
          />
        </FormGroup>
      )}
    />
  );
}
